module.exports = __webpack_public_path__ + "img/created-group.4dd6e5a7.svg";